interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  tone?: 'default' | 'success' | 'danger' | 'warning';
}

const toneStyles: Record<NonNullable<StatCardProps['tone']>, string> = {
  default: 'rgba(37, 99, 235, 0.12)',
  success: 'rgba(16, 185, 129, 0.12)',
  danger: 'rgba(220, 38, 38, 0.12)',
  warning: 'rgba(234, 179, 8, 0.18)'
};

export function StatCard({ title, value, subtitle, icon, tone = 'default' }: StatCardProps) {
  return (
    <div className="surface surface-padding" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        {icon && (
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '12px',
              display: 'grid',
              placeItems: 'center',
              fontSize: '1.2rem',
              background: toneStyles[tone]
            }}
          >
            {icon}
          </div>
        )}
        <div>
          <div className="text-muted" style={{ fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            {title}
          </div>
          <div style={{ fontSize: '1.75rem', fontWeight: 600 }}>{value}</div>
        </div>
      </div>
      {subtitle && <div className="text-muted" style={{ fontSize: '0.85rem' }}>{subtitle}</div>}
    </div>
  );
}

